import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

type Props = SvgIconProps;

const PersonCheckIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon viewBox="0 0 18 18" {...props}>
      <path
        d="M9.75 10.5465V16.5H3C2.99992 15.6487 3.181 14.8071 3.5312 14.0312C3.8814 13.2553 4.39271 12.5627 5.03116 11.9996C5.66961 11.4365 6.42058 11.0157 7.23418 10.7652C8.04778 10.5146 8.90538 10.4401 9.75 10.5465ZM9 9.75C6.51375 9.75 4.5 7.73625 4.5 5.25C4.5 2.76375 6.51375 0.75 9 0.75C11.4862 0.75 13.5 2.76375 13.5 5.25C13.5 7.73625 11.4862 9.75 9 9.75ZM13.3447 14.9355L15.996 12.2842L17.0572 13.3447L13.3447 17.0572L10.6927 14.4052L11.754 13.3447L13.344 14.9355H13.3447Z"
        fill={colors.primary}
      />
    </SvgIcon>
  );
};

export default PersonCheckIcon;
